/**
 * 官网页脚社交媒体账号（国际在线运营）
 */
export const BC_SOCIAL_FACEBOOK =
  'https://www.facebook.com/profile.php?id=61595136576309';

export const BC_SOCIAL_X = 'https://x.com/Nanjing2026TG';

/** Instagram / YouTube 暂未开放，页脚仍走「敬请期待」 */
export const BC_SOCIAL_INSTAGRAM = '';
export const BC_SOCIAL_YOUTUBE = '';



// WEBPACK FOOTER //
// ./src/page/mainindex/bcSocialLinks.js